const event = "https://superstudent.niecindonesia.com/event";
const master = "https://superstudent.niecindonesia.com/api/v1/application/master";
const membership = "http://103.41.205.45:8020";
const melbournepolyKey = '1daWPrZjRmHzjBBQfT6w8GCocvhi7cQp';
const masterKey = 'koibg3kyOxX73kKTNwCsbNXnocy6nMPQ';
const regisToken = 'eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ';


//provinces
const API_URL = {
    event,
    master,
    membership,
    melbournepolyKey,
    masterKey,
    regisToken
}

export default API_URL;